import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Toasts from "../liveOrder/Toasts";

export default function Layout({ children }) {
  const [menuCollapse, setMenuCollapse] = useState(true);

  return (
    <div className={`app ${menuCollapse ? "sidebar-collapsed" : ""}`}>
      <Sidebar menuCollapse={menuCollapse} setMenuCollapse={setMenuCollapse} />
      <div className="main">
        <Header />
        {children}
      </div>
      <Toasts />
    </div>
  );
}
